import React from "react";


function CateringOffersSection(){

    return(
        <>
        </>
    );
}

export default CateringOffersSection;